import Button from '../../st-button/st-button'
import styles from './denial-script-overlay.module.css'

/**
 * Full-viewport, read-aloud presentation of the district deny script.
 *
 * Shown *after* a visitor is denied (blocked / No-Fly Block, staff-confirmed
 * Warn, or confirmed sex-offender match) so the front-desk clerk has one
 * focused, legible screen to read to the visitor. Deliberately owns nothing
 * about the deny decision — the caller records the deny, hands us the script
 * text, and we call back onDone when the clerk is finished.
 */
export const DenialScriptOverlay = (props: { script: string; onDone: () => void }) => {
    return (
        <div class={styles['overlay']} role="dialog" aria-modal="true" aria-label="Visitor denied — district script to read aloud">
            <div class={styles['panel']}>
                <div class={styles['header']}>
                    <i class="fas fa-ban" aria-hidden="true" />
                    <span>Visitor Denied</span>
                </div>
                <div class={styles['prompt']}>Please read the following to the visitor:</div>
                <div
                    class={styles['script']}
                    innerHTML={props.script || 'This visitor has been denied entry.'}
                />
                <div class={styles['actions']}>
                    <Button type="primary" icon="fas fa-check" onClick={() => props.onDone()}>Done</Button>
                </div>
            </div>
        </div>
    )
}
